module.exports = __webpack_public_path__ + "images/init/member-visitor-c3fbcb31b1af38b0cb9f6738384d0a29.png";